import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import BreadCrumbContainer from '../common/breadcrumbContainer/breadcrumbContainer';
import CostCodesList from './costcodesList';
import CostCodeProjects from './CostcodeProjects';

import { getCategories, getTemplates } from './state/costcodes.actions';
import { getProjects } from '../projects/state/projects.actions';
import { setBreadcrumb } from '../common/breadcrumbContainer/state/breadcrumb.actions';

import Permissions from '../auth/Permissions';

function CostCodes() {
  const dispatch = useDispatch();
  const projects = useSelector((state) => state.projects.projects);
  const crumbs = useSelector((state) => state.breadcrumb);

  useEffect(() => {
    dispatch(setBreadcrumb([{
      text: 'Cost Codes',
      icon: 'swap',
    }]));
    dispatch(getCategories());
    dispatch(getProjects());
    dispatch(getTemplates());
  }, []);

  if (!Permissions.has('COSTCODES_WRITE')) return <Redirect to="/dashboard" />;

  const setBreadcrumbProp = (breadcrumb) => dispatch(setBreadcrumb(breadcrumb));

  return (
    <BreadCrumbContainer crumbs={crumbs}>
      <Route
        exact
        path="/costcodes/global"
        render={() => (
          <CostCodesList
            setBreadcrumb={setBreadcrumbProp}
          />
        )}
      />
      <Route
        exact
        path="/costcodes/project-specific"
        render={() => (
          <CostCodeProjects
            projects={projects}
            setBreadcrumb={setBreadcrumbProp}
          />
        )}
      />
    </BreadCrumbContainer>
  );
}

export default CostCodes;
